/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolEmptyRequest,
  MarqCommonProtocolFileResponse,
  PerfCommercePerformanceEnforcementProtocolsExportListingsRawRequest,
  PerfCommercePerformanceEnforcementProtocolsExportListingsRawResponse,
  PerfCommercePerformanceEnforcementProtocolsGetAvailableTabsResponse,
  PerfCommercePerformanceEnforcementProtocolsGetListingCountByTabRequest,
  PerfCommercePerformanceEnforcementProtocolsGetListingCountByTabResponse,
  PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeRequest,
  PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeResponse,
  PerfCommercePerformanceEnforcementProtocolsGetRemovedDataRequest,
  PerfCommercePerformanceEnforcementProtocolsGetRemovedDataResponse,
  PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
  PerfCommercePerformanceEnforcementProtocolsTopDataResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PerformanceEnforcement<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementTabsCreate
   * @request POST:/performance/enforcement/tabs
   */
  enforcementTabsCreate = (data: MarqCommonProtocolEmptyRequest, params: RequestParams = {}) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsGetAvailableTabsResponse, any>({
      path: `/performance/enforcement/tabs`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementCountCreate
   * @request POST:/performance/enforcement/count
   */
  enforcementCountCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsGetListingCountByTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsGetListingCountByTabResponse, any>({
      path: `/performance/enforcement/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementCountsOverTimeCreate
   * @request POST:/performance/enforcement/counts-over-time
   */
  enforcementCountsOverTimeCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeResponse, any>({
      path: `/performance/enforcement/counts-over-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementRemovedDataCreate
   * @request POST:/performance/enforcement/removed-data
   */
  enforcementRemovedDataCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsGetRemovedDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsGetRemovedDataResponse, any>({
      path: `/performance/enforcement/removed-data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementTopCountryCreate
   * @request POST:/performance/enforcement/top-country
   */
  enforcementTopCountryCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsTopDataResponse, any>({
      path: `/performance/enforcement/top-country`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementTopPlatformCreate
   * @request POST:/performance/enforcement/top-platform
   */
  enforcementTopPlatformCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsTopDataResponse, any>({
      path: `/performance/enforcement/top-platform`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementTopAssetCreate
   * @request POST:/performance/enforcement/top-asset
   */
  enforcementTopAssetCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsTopDataResponse, any>({
      path: `/performance/enforcement/top-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementTopInfringementTypeCreate
   * @request POST:/performance/enforcement/top-infringement-type
   */
  enforcementTopInfringementTypeCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsTopDataResponse, any>({
      path: `/performance/enforcement/top-infringement-type`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementExportListingsRawCreate
   * @request POST:/performance/enforcement/export-listings-raw
   */
  enforcementExportListingsRawCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsExportListingsRawRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommercePerformanceEnforcementProtocolsExportListingsRawResponse, any>({
      path: `/performance/enforcement/export-listings-raw`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementExportCountsOverTimeCreate
   * @request POST:/performance/enforcement/export-counts-over-time
   */
  enforcementExportCountsOverTimeCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsGetListingCountsOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/enforcement/export-counts-over-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementExportTopCountryCreate
   * @request POST:/performance/enforcement/export-top-country
   */
  enforcementExportTopCountryCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/enforcement/export-top-country`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementExportTopPlatformCreate
   * @request POST:/performance/enforcement/export-top-platform
   */
  enforcementExportTopPlatformCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/enforcement/export-top-platform`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementExportTopAssetCreate
   * @request POST:/performance/enforcement/export-top-asset
   */
  enforcementExportTopAssetCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/enforcement/export-top-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceEnforcement
   * @name EnforcementExportTopInfringementTypeCreate
   * @request POST:/performance/enforcement/export-top-infringement-type
   */
  enforcementExportTopInfringementTypeCreate = (
    data: PerfCommercePerformanceEnforcementProtocolsTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/enforcement/export-top-infringement-type`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
